<form [ngClass]="{'pending': pending === true}" [formGroup]="form" (submit)="submit()">
  <label>Connexion via adresse courriel et mot de passe</label>

  <small class="alert-danger p-4 mb-2" *ngIf="error">
    {{error.message}}
  </small>

  <div class="p-4" style="background-color: #f6f6f6">
    <spaq-input-email [form]="form"></spaq-input-email>
    <spaq-input-password [form]="form"></spaq-input-password>
    <a routerLink="/auth/password/forgot" class="d-block mt-1 cta" href="javascript://">Mot de passe
      perdu?</a>

    <button [primary]="true" kendoButton class="w-100 mt-4" type="submit">Connexion</button>
    <button [primary]="false" kendoButton class="w-100 mt-4" routerLink="/auth/register/choose" type="button">Inscription</button>
  </div>
</form>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/components/login-email/login-email.component.html